// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tR","itemWrapper":"tS st","itemStyle":"tT su"};